<template>
  <div class="flex items-center gap-2">
    <Button
      type="button"
      icon="pi pi-ellipsis-v"
      @click="toggleMenu"
      aria-haspopup="true"
      aria-controls="overlay_menu"
      severity="secondary"
      variant="text"
    />
    <Menu ref="menu" id="overlay_menu" :model="menuItems" :popup="true" />
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import Button from 'primevue/button'
import Menu from 'primevue/menu'
import { reloadAllStores } from '@/stores/reloadAllStores'
import { useDebugStore } from '@/stores/debugStore'
import { useAuthStore } from '@/stores/authStore'

const router = useRouter()
const menu = ref()
const isDev = import.meta.env.MODE === 'dev'
const debugStore = useDebugStore()
const authStore = useAuthStore()

const toggleMenu = (event: Event) => {
  menu.value.toggle(event)
}

const menuItems = computed(() => [
  {
    label: 'About',
    icon: 'pi pi-question-circle',
    command: () => {
      router.push('/version')
    },
  },
  {
    label: 'Settings',
    icon: 'pi pi-cog',
    command: () => {
      // TODO: Implement settings functionality
      console.log('Settings clicked')
      router.push('/settings')
    },
  },
  {
    label: 'Reload Data',
    icon: 'pi pi-refresh',
    command: async () => {
      await reloadAllStores()
    },
  },
  ...(authStore.isSaasAdmin
    ? [
        {
          label: 'Admin',
          icon: 'pi pi-wrench',
          command: () => {
            router.push('/admin')
          },
        },
      ]
    : []),
  ...(isDev
    ? [
        {
          label: 'Debug',
          icon: 'pi pi-bug',
          command: () => {
            debugStore.showDialog()
          },
        },
      ]
    : []),
  {
    label: 'Logout',
    icon: 'pi pi-sign-out',
    command: async () => {
      try {
        const tenantSlug = await authStore.logout()
        // Redirect to tenant-specific login if we have a tenant slug, otherwise generic login
        if (tenantSlug) {
          router.push(`/login/${tenantSlug}`)
        } else {
          router.push('/login')
        }
      } catch (error) {
        console.error('Logout failed:', error)
      }
    },
  },
])
</script>
